<div *ngIf="show" class="alert alert-refresh alert-dismissible fade in" role="alert">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><i class="fa fa-refresh" alt="Refresh" (click)="action()"></i>
  </button>
  <strong><ng-content></ng-content></strong>
</div>
